// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3fEfV","colMaxWidth":"Table_colMaxWidth__3AeJU"};